import { z } from 'zod';

import { ContentfulSysSchema } from './contentful-sys.validator';

export const UnitOfMeasureEntrySchema = z.object({
  sys: ContentfulSysSchema,
  fields: z.looseObject({
    id: z.enum(['imperial', 'metric']),
    value: z.enum(['unit-of-measure.imperial', 'unit-of-measure.metric']),
    default: z.boolean()
  }),
  metadata: z
    .object({
      tags: z.array(z.any()).optional().nullable()
    })
    .optional()
    .nullable()
});
